export const heroStats = [
  { label: "已收录关键词", value: "128,640", unit: "个" },
  { label: "人物索引档案", value: "36,420", unit: "份" },
  { label: "今日新增爆料", value: "1,284", unit: "条" },
  { label: "专题合集", value: "512", unit: "期" },
];

export const heroHotTags = [
  "塌房",
  "道歉声明",
  "学历造假",
  "直播翻车",
  "天价违约金",
  "私生活争议",
  "代言解约",
];

export const hotKeywords = [
  { keyword: "塌房", count: "42,180", trend: "up", note: "选秀艺人集中区" },
  { keyword: "道歉声明", count: "28,905", trend: "up", note: "公关话术索引" },
  { keyword: "学历造假", count: "21,344", trend: "flat", note: "履历争议" },
  { keyword: "直播翻车", count: "19,872", trend: "up", note: "带货现场记录" },
  { keyword: "天价违约金", count: "16,530", trend: "down", note: "合约纠纷" },
  { keyword: "私生活争议", count: "15,208", trend: "up", note: "情感线索引" },
  { keyword: "代言解约", count: "12,760", trend: "flat", note: "品牌切割" },
  { keyword: "数据造假", count: "11,905", trend: "up", note: "榜单注水" },
  { keyword: "团队内讧", count: "9,842", trend: "down", note: "工作室分部" },
  { keyword: "抄袭风波", count: "8,613", trend: "flat", note: "作品比对" },
  { keyword: "耍大牌", count: "7,455", trend: "up", note: "片场目击" },
  { keyword: "学历查重", count: "6,120", trend: "up", note: "论文疑点" },
];

export const rankWordBoard = [
  { rank: 1, title: "男星L某 恋情实锤曝光", category: "情感线", heat: 98, trend: "up", delta: "+126%" },
  { rank: 2, title: "头部主播A 直播间货不对板", category: "带货", heat: 94, trend: "up", delta: "+88%" },
  { rank: 3, title: "选秀歌手S某 早期言论被翻出", category: "言论", heat: 90, trend: "up", delta: "+63%" },
  { rank: 4, title: "导演W某 片场争议录音流出", category: "片场", heat: 85, trend: "down", delta: "-12%" },
  { rank: 5, title: "网红组合M 内部分成纠纷", category: "分成", heat: 81, trend: "up", delta: "+41%" },
  { rank: 6, title: "演员H某 代言品牌连夜撤稿", category: "代言", heat: 76, trend: "flat", delta: "±0%" },
  { rank: 7, title: "女团成员Z 学历疑点被扒", category: "学历", heat: 71, trend: "up", delta: "+29%" },
  { rank: 8, title: "综艺节目组 剪辑双标质疑", category: "剪辑", heat: 66, trend: "down", delta: "-8%" },
];

export const rankPersonBoard = [
  { rank: 1, title: "L某（选秀歌手）", category: "情感线索引", heat: 96, trend: "up", delta: "+112%" },
  { rank: 2, title: "A某（头部主播）", category: "带货争议", heat: 93, trend: "up", delta: "+95%" },
  { rank: 3, title: "S某（综艺常客）", category: "言论争议", heat: 88, trend: "up", delta: "+70%" },
  { rank: 4, title: "W某（导演）", category: "片场争议", heat: 83, trend: "down", delta: "-15%" },
  { rank: 5, title: "M某（网红组合成员）", category: "拆分纠纷", heat: 79, trend: "up", delta: "+36%" },
  { rank: 6, title: "H某（影视演员）", category: "代言风波", heat: 74, trend: "flat", delta: "±0%" },
  { rank: 7, title: "Z某（女团成员）", category: "学历疑点", heat: 69, trend: "up", delta: "+24%" },
  { rank: 8, title: "Q某（电竞选手）", category: "赛场外事件", heat: 64, trend: "down", delta: "-6%" },
];

export const featureCollections = [
  {
    title: "选秀出道艺人 塌房合集",
    desc: "从练习生时期的旧帖，到出道后的言论与行程记录，按时间线整理的选秀圈争议专题。",
    tag: "专题 · 合集",
    count: "收录 128 条",
    updated: "3 小时前更新",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20investigation%20board%20with%20torn%20newspaper%20clippings%20connected%20by%20red%20thread%20on%20a%20dark%20table%2C%20warm%20directional%20light%2C%20top%20view%2C%20no%20people%2C%20artistic%20moody%20composition&width=900&height=660&seq=h18col01&orientation=landscape",
  },
  {
    title: "带货直播间 翻车现场",
    desc: "货不对板、售后服务、价格虚高——把直播间里的争议片段做成可检索的索引。",
    tag: "专题 · 带货",
    count: "收录 96 条",
    updated: "6 小时前更新",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20still%20life%20of%20studio%20spotlights%20and%20parcel%20boxes%20on%20a%20stage%20floor%2C%20deep%20crimson%20and%20charcoal%20palette%2C%20dramatic%20shadows%2C%20editorial%20photography%2C%20no%20people&width=700&height=540&seq=h18col02&orientation=landscape",
  },
  {
    title: "合约与解约 纠纷档案",
    desc: "违约金、经纪约、工作室分账，把公开披露的合约矛盾整理成结构化索引。",
    tag: "专题 · 合约",
    count: "收录 74 条",
    updated: "1 天前更新",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20stacked%20paper%20contracts%20and%20a%20wax%20seal%20on%20a%20warm%20wooden%20desk%2C%20amber%20lighting%2C%20shallow%20depth%20of%20field%2C%20editorial%20still%20life%2C%20no%20people&width=700&height=540&seq=h18col03&orientation=landscape",
  },
  {
    title: "言论考古 时间线",
    desc: "按年份回放被翻出的旧帖、旧采访与旧节目片段，附出处与时间戳。",
    tag: "专题 · 考古",
    count: "收录 158 条",
    updated: "8 小时前更新",
    image:
      "https://readdy.ai/api/search-image?query=retro%20archive%20shelf%20with%20old%20microfilm%20reels%20and%20labeled%20cardboard%20boxes%2C%20warm%20sepia%20tone%2C%20soft%20window%20light%2C%20editorial%20photography%2C%20no%20people&width=700&height=540&seq=h18col04&orientation=landscape",
  },
  {
    title: "品牌代言 切割记录",
    desc: "从官宣到撤稿，记录品牌与艺人在争议爆发前后的每一次公开动作。",
    tag: "专题 · 代言",
    count: "收录 63 条",
    updated: "2 天前更新",
    image:
      "https://readdy.ai/api/search-image?query=blank%20poster%20frames%20being%20taken%20down%20from%20a%20concrete%20wall%2C%20muted%20warm%20neutral%20tones%2C%20dramatic%20side%20light%2C%20minimal%20editorial%20composition%2C%20no%20people&width=700&height=540&seq=h18col05&orientation=landscape",
  },
];

export const personEntries = [
  {
    name: "L某",
    role: "选秀歌手",
    tags: ["情感线", "旧帖考古"],
    mentions: "18,240",
    heat: 96,
    avatar:
      "https://readdy.ai/api/search-image?query=minimal%20abstract%20faceless%20portrait%20silhouette%20with%20warm%20rim%20light%20on%20a%20plain%20beige%20studio%20background%2C%20editorial%2C%20muted%20warm%20tones&width=400&height=400&seq=h18p01&orientation=squarish",
  },
  {
    name: "A某",
    role: "头部主播",
    tags: ["带货争议", "售后"],
    mentions: "16,905",
    heat: 93,
    avatar:
      "https://readdy.ai/api/search-image?query=minimal%20abstract%20faceless%20portrait%20silhouette%20with%20crimson%20rim%20light%20on%20a%20plain%20warm%20grey%20studio%20background%2C%20editorial%2C%20muted%20tones&width=400&height=400&seq=h18p02&orientation=squarish",
  },
  {
    name: "S某",
    role: "综艺常客",
    tags: ["言论争议"],
    mentions: "13,470",
    heat: 88,
    avatar:
      "https://readdy.ai/api/search-image?query=minimal%20abstract%20faceless%20portrait%20silhouette%20with%20amber%20rim%20light%20on%20a%20plain%20cream%20studio%20background%2C%20editorial%2C%20muted%20warm%20tones&width=400&height=400&seq=h18p03&orientation=squarish",
  },
  {
    name: "W某",
    role: "导演",
    tags: ["片场争议"],
    mentions: "11,830",
    heat: 83,
    avatar:
      "https://readdy.ai/api/search-image?query=minimal%20abstract%20faceless%20portrait%20silhouette%20with%20cool%20neutral%20rim%20light%20on%20a%20plain%20taupe%20studio%20background%2C%20editorial%2C%20muted%20tones&width=400&height=400&seq=h18p04&orientation=squarish",
  },
  {
    name: "M某",
    role: "网红组合成员",
    tags: ["拆分纠纷", "分成"],
    mentions: "10,205",
    heat: 79,
    avatar:
      "https://readdy.ai/api/search-image?query=minimal%20abstract%20faceless%20portrait%20silhouette%20with%20soft%20warm%20rim%20light%20on%20a%20plain%20sand%20studio%20background%2C%20editorial%2C%20muted%20tones&width=400&height=400&seq=h18p05&orientation=squarish",
  },
  {
    name: "Z某",
    role: "女团成员",
    tags: ["学历疑点"],
    mentions: "8,940",
    heat: 69,
    avatar:
      "https://readdy.ai/api/search-image?query=minimal%20abstract%20faceless%20portrait%20silhouette%20with%20golden%20rim%20light%20on%20a%20plain%20ivory%20studio%20background%2C%20editorial%2C%20muted%20warm%20tones&width=400&height=400&seq=h18p06&orientation=squarish",
  },
];

export const indexZones = [
  { name: "娱乐圈", icon: "ri-movie-2-line", count: "48,210", desc: "影视、综艺、音乐圈的争议线索" },
  { name: "直播带货", icon: "ri-live-line", count: "26,540", desc: "直播间翻车、货不对板与售后争议" },
  { name: "网红博主", icon: "ri-user-voice-line", count: "31,880", desc: "短视频与社交平台创作者相关索引" },
  { name: "经纪合约", icon: "ri-file-list-3-line", count: "12,760", desc: "违约金、解约与工作室分账纠纷" },
  { name: "商业品牌", icon: "ri-store-2-line", count: "9,455", desc: "代言、撤稿与品牌公关动作" },
  { name: "电竞选手", icon: "ri-gamepad-line", count: "7,320", desc: "赛场外事件与选手言论记录" },
  { name: "体育人物", icon: "ri-run-line", count: "6,108", desc: "赛事争议与个人形象风波" },
  { name: "知识区作者", icon: "ri-book-2-line", count: "5,612", desc: "履历、论文与专业身份疑点" },
];

export const latestFeed = [
  {
    time: "12 分钟前",
    title: "男星L某工作室发布律师声明，评论区被要求公布完整时间线",
    summary: "声明中提到「保留追责权利」，但未回应旧帖截图来源，相关话题热度持续攀升。",
    tag: "声明",
    heat: 98,
  },
  {
    time: "48 分钟前",
    title: "头部主播A直播回应货不对板：承诺三倍赔付并开放批次查询",
    summary: "团队在直播中展示了退货流程截图，但未公布涉事批次的总量，网友仍在索引评论区凭证。",
    tag: "回应",
    heat: 94,
  },
  {
    time: "2 小时前",
    title: "选秀歌手S某早期采访片段被重新翻出，时间线索引已更新",
    summary: "索引区补充了 2019 年至 2021 年的三期采访出处，附带原始视频时间戳。",
    tag: "考古",
    heat: 90,
  },
  {
    time: "4 小时前",
    title: "导演W某片场录音流出，制片方回应称「断章取义」",
    summary: "录音总时长约 6 分钟，双方各执一词，专题页已按争议点分段落整理。",
    tag: "录音",
    heat: 85,
  },
  {
    time: "6 小时前",
    title: "网红组合M被曝分成纠纷，成员各自注册新账号",
    summary: "三方均未正面回应，但账号作品发布时间出现明显错开，索引区标注了关键时间点。",
    tag: "纠纷",
    heat: 81,
  },
  {
    time: "9 小时前",
    title: "演员H某代言品牌连夜撤换物料，官网图集已清空",
    summary: "品牌方未发布说明，仅将相关页面重定向至新品专区，代言切割记录同步更新。",
    tag: "代言",
    heat: 76,
  },
  {
    time: "昨天 22:40",
    title: "女团成员Z某学历背景被质疑，学校官网课程信息引发讨论",
    summary: "索引区整理了她的公开履历与报道时间差，并标注了三处待核实信息。",
    tag: "学历",
    heat: 71,
  },
  {
    time: "昨天 19:15",
    title: "综艺节目组被指剪辑双标，嘉宾镜头分配引发新一轮索引",
    summary: "节目组尚未回应，热度词「剪辑双标」当日搜索量上涨约 41%。",
    tag: "剪辑",
    heat: 66,
  },
];

export const faqs = [
  {
    q: "18黑料网收录的是什么内容？",
    a: "本站是一个关键词索引型页面，把公开传播的热点词、人物争议线索与专题合集按检索维度重新组织，方便快速定位相关话题的出处与时间线。",
  },
  {
    q: "如何用关键词搜索黑料线索？",
    a: "在首屏或人物查询入口输入人物称呼、事件名或热点词（例如「塌房」「代言解约」），即可跳转到对应的索引分区与专题合集，查看该关键词下的收录条目。",
  },
  {
    q: "热点词指数与热度榜是怎么排序的？",
    a: "热度榜综合关键词的收录条目数、近期检索量与来源分布给出热度值，分为热搜词榜与人物榜两类，每天多次刷新，指标仅反映索引活跃度。",
  },
  {
    q: "人物黑料查询入口能查到什么？",
    a: "输入人物称呼或别名后，可查看该人物的档案卡，包括相关标签、被提及次数、参与过的专题合集以及线索出现的时间区间，便于自行交叉核对。",
  },
];